import { h, Component } from 'preact';
import * as jsonPointer from 'utils/jsonPointer';
import { getCurrentHubDomain } from 'utils/studioConfig';
import { joinClasses } from 'utils/utils';

import Badge from 'components/badge/badge';
import Button from 'components/button/button';
import Share from 'components/icons/share';
import WithTooltip from 'components/tooltip/withTooltip';

import s from 'components/editor/sidebar.sss';

export default class EditorSidebar extends Component {
	s = s;

	get title() {
		return this.props.config.title;
	}

	get data() {
		const { activeSection, data } = this.props;
		return jsonPointer.get(data, activeSection.dataRoot);
	}

	get isLive() {
		return !!this.data?.commits?.publish;
	}

	get url() {
		const slug = this.props.config.slug;
		if (!slug) return null;

		const path = slug === 'landing' ? '' : slug; // For landing page, the URL is the root domain
		return `https://${getCurrentHubDomain()}/${path}`;
	}

	constructor(props) {
		super(props);

		this.state = {
			sidebarCollapsed: false,
		};

		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.renderSection = this.renderSection.bind(this);
	}

	toggleSidebar() {
		this.setState({ sidebarCollapsed: !this.state.sidebarCollapsed });
	}

	renderBadge(type, changes) {
		const badge = <Badge dark type={type} alert={!!changes} />;

		// If there are no unpublished changes, just show the badge
		if (!changes) {
			return badge;
		}

		// If there are unpublished changes, show a tooltip on hover
		return (
			<WithTooltip direction="bottom" align="start" tooltip="Live, with unpublished changes">
				{badge}
			</WithTooltip>
		);
	}

	renderSubHeading() {}

	renderPageStatus() {
		const { current, publish } = this.data?.commits || {};
		const pageStatus = this.isLive ? 'live' : 'draft';
		const unpublishedChanges = this.isLive && current?.at > publish?.at;

		return this.renderBadge(pageStatus, unpublishedChanges);
	}

	renderTitle() {
		return (
			<h2 class={this.s.title}>{this.title}</h2>
		);
	}

	renderHeader() {
		return (
			<div class={this.s.header}>
				{this.renderTitle()}
				{this.url && <a href={this.url} target="_blank" rel="noopener">{this.url} <Share /></a>}
				{this.renderSubHeading()}
				{this.renderPageStatus()}
			</div>
		);
	}

	renderSection(section) {
		const activeSection = this.props.activeSection;
		return <a class={joinClasses(this.s.section, section === activeSection && this.s.active)} href={`#${this.props.config.basePath}/${section.path}`}>{section.name}</a>;
	}

	renderContent() {
		const config = this.props.config;
		return (
			<div class={this.s.inner}>
				{this.renderHeader()}
				<div class={this.s.sections}>
					{config.sections.map(this.renderSection)}
				</div>
			</div>
		);
	}

	render() {
		return (
			<div class={joinClasses(this.s.sidebar, this.state.sidebarCollapsed && this.s.collapsed)} key="sidebar">
				<Button dark icon="sidebar-collapse" class={this.s.toggle} onClick={this.toggleSidebar} />
				{this.renderContent()}
			</div>
		);
	}
}